export default __webpack_public_path__ + "static/media/logo.8e7b1f2c.png";